/**
 * Sonuç sayfasının varsayılan stilleri — `styles.ts` ile aynı ilkeler:
 * `<head>`'in başına enjekte (mağaza kuralları sonra gelip ezebilsin), tek
 * class seçicileri, renkler CSS değişkenlerinden. Değişken adları arama
 * çubuğuyla aynı (`--shs-*`): mağaza tek satırla ikisini birden boyar.
 *
 * Class isimleri public sözleşmedir (`shs-results*`, `shs-card*`, `shs-facet*`)
 * — değiştirmek yeni major gerektirir.
 *
 * Bu blok bir template literal içinde: yorumlara backtick YAZMAYIN.
 */

export const RESULTS_STYLE_ID = "shs-results-styles";

export const resultsStyles = `
.shs-results{
  --shs-bg:#fff; --shs-fg:#111827; --shs-muted:#6b7280; --shs-border:#e5e7eb;
  --shs-accent:#0055ff; --shs-accent-ring:rgba(0,85,255,.22);
  --shs-hover:#f3f4f6; --shs-radius:12px; --shs-font:inherit;
  --shs-columns:4; --shs-sale:#dc2626; --shs-star:#f59e0b;
  box-sizing:border-box; width:100%; color:var(--shs-fg);
  font-family:var(--shs-font); font-size:15px; line-height:1.5;
}
.shs-results *{box-sizing:border-box}
.shs-results[data-theme="dark"]{
  --shs-bg:#111827; --shs-fg:#f9fafb; --shs-muted:#9ca3af;
  --shs-border:rgba(255,255,255,.14); --shs-hover:rgba(255,255,255,.07);
}
@media (prefers-color-scheme:dark){
  .shs-results[data-theme="auto"]{
    --shs-bg:#111827; --shs-fg:#f9fafb; --shs-muted:#9ca3af;
    --shs-border:rgba(255,255,255,.14); --shs-hover:rgba(255,255,255,.07);
  }
}

/* Sertleştirme: mağaza temalarının genel input/img/button kuralları sızmasın. */
.shs-results .shs-card__image{max-width:100% !important; height:100% !important; margin:0 !important; padding:0 !important; border:0 !important; display:block !important}
.shs-results .shs-facet__check{width:16px !important; height:16px !important; margin:0 !important; padding:0 !important; flex:0 0 auto}

.shs-results__head{display:flex; flex-wrap:wrap; align-items:center; justify-content:space-between; gap:10px 16px; margin-bottom:14px}
.shs-results__title{margin:0; font-size:18px; font-weight:600}
.shs-results__count{color:var(--shs-muted); font-weight:400; font-size:14px}
.shs-results__tools{display:flex; align-items:center; gap:8px}
.shs-results__sort,.shs-results__filters-btn,.shs-results__btn{
  font:inherit; font-size:14px; color:var(--shs-fg); background:var(--shs-bg);
  border:1px solid var(--shs-border); border-radius:8px; padding:7px 10px; cursor:pointer;
}
.shs-results__sort:focus-visible,.shs-results__filters-btn:focus-visible,.shs-results__btn:focus-visible,
.shs-pager__btn:focus-visible,.shs-card:focus-visible{outline:none; border-color:var(--shs-accent); box-shadow:0 0 0 3px var(--shs-accent-ring)}
.shs-results__filters-btn{display:none}
.shs-results__suggestion{margin:0 0 12px; font-size:14px; color:var(--shs-muted)}
.shs-results__suggestion a{color:var(--shs-accent); font-weight:600; text-decoration:none; cursor:pointer}

.shs-results__chips{display:flex; flex-wrap:wrap; gap:6px; margin-bottom:14px}
.shs-results__chips:empty{display:none}
.shs-chip{
  display:inline-flex; align-items:center; gap:6px; font:inherit; font-size:13px;
  border:1px solid var(--shs-border); border-radius:999px; padding:3px 10px;
  background:var(--shs-hover); color:var(--shs-fg); cursor:pointer;
}
.shs-chip--clear{background:transparent; color:var(--shs-accent); border-color:transparent}

.shs-results__layout{display:grid; grid-template-columns:240px minmax(0,1fr); gap:24px; align-items:start}
.shs-results__layout[data-no-facets]{grid-template-columns:minmax(0,1fr)}
.shs-results__facets[hidden]{display:none}
.shs-results__drawer-head{display:none}
.shs-results__overlay{display:none}

.shs-facet{border-bottom:1px solid var(--shs-border); padding:12px 0}
.shs-facet:first-child{padding-top:0}
.shs-facet:last-child{border-bottom:0}
.shs-facet__title{margin:0 0 8px; font-size:14px; font-weight:600}
.shs-facet__list{list-style:none; margin:0; padding:0; display:flex; flex-direction:column; gap:4px}
.shs-facet__option{display:flex; align-items:center; gap:8px; font-size:14px; cursor:pointer; padding:2px 0}
.shs-facet__label{flex:1 1 auto; min-width:0; overflow:hidden; text-overflow:ellipsis; white-space:nowrap}
.shs-facet__count{flex:0 0 auto; font-size:12px; color:var(--shs-muted); font-variant-numeric:tabular-nums}
.shs-facet__option[data-empty]{opacity:.5}
.shs-facet__more{margin-top:6px; padding:0; border:0; background:none; font:inherit; font-size:13px; color:var(--shs-accent); cursor:pointer}
.shs-facet__search{
  width:100%; margin:0 0 8px; padding:6px 8px; font:inherit; font-size:13px; color:var(--shs-fg);
  background:var(--shs-bg); border:1px solid var(--shs-border); border-radius:6px;
}
.shs-facet__range{display:flex; align-items:center; gap:6px; margin-top:8px}
.shs-facet__range input{
  width:0; flex:1 1 0; min-width:0; padding:6px 8px; font:inherit; font-size:13px; color:var(--shs-fg);
  background:var(--shs-bg); border:1px solid var(--shs-border); border-radius:6px;
}
.shs-facet__stars{color:var(--shs-star); letter-spacing:1px}

.shs-results__main{min-width:0; position:relative}
.shs-results__main[data-loading] .shs-results__grid{opacity:.45; pointer-events:none; transition:opacity .15s}
.shs-results__grid{
  list-style:none; margin:0; padding:0; display:grid; gap:16px;
  grid-template-columns:repeat(var(--shs-columns),minmax(0,1fr));
}
.shs-card{
  display:flex; flex-direction:column; height:100%; text-decoration:none; color:inherit;
  border:1px solid var(--shs-border); border-radius:var(--shs-radius); overflow:hidden;
  background:var(--shs-bg); transition:box-shadow .15s ease, border-color .15s ease;
}
.shs-card:hover{border-color:var(--shs-muted); box-shadow:0 8px 24px -12px rgba(0,0,0,.25)}
.shs-card__media{position:relative; aspect-ratio:1/1; background:#fff; display:flex; align-items:center; justify-content:center; overflow:hidden}
.shs-card__image{width:100%; object-fit:contain}
.shs-card__placeholder{width:100%; height:100%; background:var(--shs-hover)}
.shs-card__badge{
  position:absolute; top:8px; left:8px; background:var(--shs-sale); color:#fff;
  font-size:12px; font-weight:600; border-radius:6px; padding:2px 7px;
}
.shs-card__badge--out{background:#374151; left:auto; right:8px}
.shs-card__body{display:flex; flex-direction:column; gap:3px; padding:10px 12px 12px; flex:1 1 auto}
.shs-card__subtitle{font-size:12px; color:var(--shs-muted); overflow:hidden; text-overflow:ellipsis; white-space:nowrap}
.shs-card__title{
  margin:0; font-size:14px; font-weight:500; line-height:1.35;
  display:-webkit-box; -webkit-line-clamp:2; -webkit-box-orient:vertical; overflow:hidden;
}
.shs-card__rating{font-size:12px; color:var(--shs-muted)}
.shs-card__rating span{color:var(--shs-star)}
.shs-card__prices{margin-top:auto; padding-top:6px; display:flex; align-items:baseline; flex-wrap:wrap; gap:2px 8px}
.shs-card__price{font-size:15px; font-weight:600; font-variant-numeric:tabular-nums}
.shs-card__list-price{font-size:13px; color:var(--shs-muted); font-variant-numeric:tabular-nums}

.shs-results__state{padding:40px 16px; text-align:center; color:var(--shs-muted); font-size:15px}
.shs-results__state--error{color:#b91c1c}
.shs-results__state strong{display:block; color:var(--shs-fg); font-size:16px; margin-bottom:4px}

.shs-pager{display:flex; flex-wrap:wrap; justify-content:center; align-items:center; gap:4px; margin-top:24px}
.shs-pager:empty{display:none}
.shs-pager__btn{
  min-width:36px; height:36px; padding:0 10px; font:inherit; font-size:14px; color:var(--shs-fg);
  background:var(--shs-bg); border:1px solid var(--shs-border); border-radius:8px; cursor:pointer;
}
.shs-pager__btn[aria-current="page"]{background:var(--shs-accent); border-color:var(--shs-accent); color:#fff; font-weight:600}
.shs-pager__btn:disabled{opacity:.4; cursor:default}
.shs-pager__gap{color:var(--shs-muted); padding:0 4px}

@media (max-width:1100px){.shs-results{--shs-columns:3}}
@media (max-width:860px){
  .shs-results{--shs-columns:2}
  .shs-results__layout{grid-template-columns:minmax(0,1fr)}
  .shs-results__filters-btn{display:inline-flex}
  /* Dar ekranda filtreler alttan değil yandan açılan panelde. */
  .shs-results__facets{
    position:fixed; inset:0 auto 0 0; z-index:2147483000; width:min(88vw,360px);
    overflow-y:auto; background:var(--shs-bg); padding:0 16px 24px;
    box-shadow:0 20px 50px -12px rgba(0,0,0,.35); transform:translateX(-105%);
    transition:transform .2s ease;
  }
  .shs-results__facets[data-open]{transform:none}
  .shs-results__overlay:not([hidden]){display:block; position:fixed; inset:0; z-index:2147482999; background:rgba(15,23,42,.45)}
  .shs-results__drawer-head{
    display:flex; align-items:center; justify-content:space-between; position:sticky; top:0;
    background:var(--shs-bg); padding:14px 0; margin-bottom:6px; border-bottom:1px solid var(--shs-border);
    font-weight:600;
  }
}
@media (max-width:480px){.shs-results__grid{gap:10px}}
@media (prefers-reduced-motion:reduce){.shs-results__facets,.shs-card{transition:none}}
`;

/** Aynı sayfada iki kez çağrılırsa ikinci kez bir şey yapmaz. */
export const injectResultsStyles = (doc: Document = document) => {
  if (doc.getElementById(RESULTS_STYLE_ID)) return;
  const el = doc.createElement("style");
  el.id = RESULTS_STYLE_ID;
  el.textContent = resultsStyles;
  const head = doc.head || doc.documentElement;
  head.insertBefore(el, head.firstChild);
};
